export default __webpack_public_path__ + "static/media/hht1_ani_02.5d34a9d6.png";